import React, { useState } from "react";
import TabNavItem from "../V2/TabNavItem";
import TabContent from "../V2/TabContent";
const Tabs = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <div className="process-content">
      <div className="steps">
        <TabNavItem
          title="Strategy"
          id="tab1"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Design"
          id="tab2"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Develop"
          id="tab3"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Maintain"
          id="tab4"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
      <div className="content">
        <TabContent id="tab1" activeTab={activeTab}>
          <h1 className="big-text">Strategy</h1>
          <p className="content-txt">
            We begin our projects by gathering information about our clients'
            requirements and needs to ensure we deliver a website that truly
            represents their brand.
          </p>
        </TabContent>
        <TabContent id="tab2" activeTab={activeTab}>
          <h1 className="big-text">Design</h1>
          <p className="content-txt">
            The design stage is where we put our heads together and craft the
            most favorable designs tailored to the brands unique direction. We
            work side by side with our clients to allow for frequent feedback.
          </p>
        </TabContent>
        <TabContent id="tab3" activeTab={activeTab}>
          <h1 className="big-text">Develop</h1>
          <p className="content-txt">
            The fun doesn't end quite yet. This is the stage where you can see
            the designs come to life. We code them line by line to keep it
            clean, efficient and fast.
          </p>
        </TabContent>
        <TabContent id="tab4" activeTab={activeTab}>
          <h1 className="big-text">Maintain</h1>
          <p className="content-txt">
            The final stage is the most important key to a strong partnership.
            Maintenance. We provide lifetime hosting, revisions and support. You
            want some content added? A new page? More functionality? No problem.
            We'll always be there for you to add whatever you like, whenever.
          </p>
        </TabContent>
        {/*TAB CONTENT GOES HERE */}
      </div>
    </div>
  );
};

export default Tabs;
